import rawData from "./rawData.json";

const data = rawData;

const keys = Object.keys(data);

keys.forEach((key, i) => {
  data[key].projectUrl = key;
});

export { data };
